module.exports = __webpack_public_path__ + "static/media/PATS_1-298w.9a8000e7.png";